type Props = {
  height?: number;
}

export const GradientLine = ({height = 2}: Props): JSX.Element => {
  return (
    <div style={{background: 'linear-gradient(90deg, #0046FF 0%, #F03C4B 52.08%, #FF6437 100%)', width: '100%', height}} />
  );
};
